"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isWindow;
function isWindow(obj) {
  /* eslint no-eq-null: 0 */
  /* eslint eqeqeq: 0 */
  return obj != null && obj == obj.window;
}
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/_rc-align@2.3.4@rc-align/lib/isWindow.js
 ** module id = 541
 ** module chunks = 0 1
 **/